export const ADD_DUPE_VEHICLE_INDEX = 'ADD_DUPE_VEHICLE_INDEX';
export const REMOVE_DUPE_VEHICLE_INDEX = 'REMOVE_DUPE_VEHICLE_INDEX';
export const CLEAN_DUPE_VEHICLE_INDEX = 'CLEAN_DUPE_VEHICLE_INDEX';
